import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  AccessRule,
  Application,
  NewRole,
} from '../../../shared/models/authorizationService.model';
import { ProfileModuleState } from '../../models/profile.model';

export const getProfileModuleState = createFeatureSelector<ProfileModuleState>('profileModule');

export const selectautoSuggestedProfiles = createSelector(
  getProfileModuleState,
  (state) => state.autoSuggest?.profiles,
);

export const selectProfile = createSelector(getProfileModuleState, (state) => state.profile);

export const selectSearchLoadResult = createSelector(
  getProfileModuleState,
  (state) => state.loadResult,
);

export const selectProfileRelationships = createSelector(
  getProfileModuleState,
  (state) => state.relationships,
);

export const selectApplications = createSelector(
  getProfileModuleState,
  (state) => state.applications,
);
export const selectApplicationGroups = createSelector(
  getProfileModuleState,
  (state) => state.applicationGroups,
);
export const selectAccessRules = createSelector(
  getProfileModuleState,
  (state) => state.accessRules,
);
export const selectRoles = createSelector(getProfileModuleState, (state) => state.roles || []);
export const selectProfileId = createSelector(
  getProfileModuleState,
  (state) => state.profile?.profileId,
);
export const selectProfileType = createSelector(
  getProfileModuleState,
  (state) => state.profile?.businessPartnerEntityType,
);

export const selectB2CProfile = createSelector(getProfileModuleState, (state) => state.b2cProfile);

export const selectApplicationsForGroup = createSelector(
  selectApplications,
  (applications: Application[], groupId: number) => {
    if (applications) {
      return applications.filter(
        (application: Application) => application.applicationGroupId === groupId,
      );
    }
  },
);

export const selectSelectedRole = createSelector(
  selectAccessRules,
  selectRoles,
  (accessRules: AccessRule[], roles: NewRole[], key: string) => {
    const accessRule = accessRules.find((rule) => rule.applicationKey === key);
    const accessRole = accessRule
      ? roles.find((role) => accessRule.roleKey === role.key)
      : undefined;
    return accessRole ? accessRole.key : undefined;
  },
);

export const selectSelectedApplicationGroups = createSelector(
  selectApplications,
  selectApplicationGroups,
  selectAccessRules,
  (applications, applicationGroups, accessRules) =>
    applicationGroups.filter((applicationGroup) =>
      applications
        .filter((application) => application.applicationGroupId === applicationGroup.id)
        .reduce(
          (include, application) =>
            include ||
            accessRules.filter((accessRule) => accessRule.applicationKey === application.key)
              .length > 0,
          false,
        ),
    ),
);

export const selectUnselectedApplicationGroups = createSelector(
  selectSelectedApplicationGroups,
  selectApplicationGroups,
  selectApplications,
  (selectedApplicationGroups, applicationGroups, applications) =>
    applicationGroups.filter(
      (applicationGroup) =>
        !selectedApplicationGroups.find(
          (selectedApplicationGroup) => selectedApplicationGroup.id === applicationGroup.id,
        ) &&
        applications.filter((application) => application.applicationGroupId === applicationGroup.id)
          .length > 0,
    ),
);
